import { ROUTE_PATH_FAQ, ROUTE_PATH_PRIVACY_POLICY, ROUTE_PATH_TERMS_CONDITIONS, ROUTE_PATH_TERMS_OF_USE } from '../../constants';
import { SiteFooterTranslations } from '../types';

export const translations: SiteFooterTranslations = {
  navMenu: {
    termsOfUse: {
      to: ROUTE_PATH_TERMS_OF_USE,
      exact: true,
      children: 'Website Terms of Use'
    },
    privacyPolicy: {
      to: ROUTE_PATH_PRIVACY_POLICY,
      exact: true,
      children: 'Privacy Policy'
    },
    faq: {
      to: ROUTE_PATH_FAQ,
      exact: true,
      children: 'FAQ'
    },
    termsAndConditions: {
      to: ROUTE_PATH_TERMS_CONDITIONS,
      exact: true,
      children: 'Terms & Conditions'
    }
  }
};
